import type { SVGProps } from 'react';

export function KingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} {...props}>
      <path d="M3 7l4.5 4L12 4l4.5 7L21 7l-2 11H5z" />
    </svg>
  );
}
